

$(function () {
    $(".widget-code-input").each(function (idx, element) {

        var highlightedClassName = "highlighted";
        var populatedClassName = "populated";
        var digitClassName = "code-input-digit";

        var $input = $(element).find("input[type=hidden]");
        var $allDigits = $(element).find("." + digitClassName);
        var maxDigits = parseInt($(element).data("length"));
        var focusOnLoad = $(element).data("focus-onload");

        $(element).on("focus", function (e) {
            _onFocus();
        });


        $(element).find("." + digitClassName).on("click", function () {
            _onFocus();
        });

        $(element).find("." + digitClassName).on("focus", function (e) {
            $(this).select();
        });

        $(element).find("." + digitClassName).on("input", function (e) {
            var value = $(this).val();

            if (value) {
                if (value.length > 1) {
                    $(this).val(value.charAt(value.length - 1));
                }

                var charCode = value.charCodeAt(0);
                if (charCode < 48 || charCode > 57) {
                    $(this).val("");
                    return;
                }

                var $h = _getHighlighted();
                _populateDigit($h);
                setTimeout(function () { _highlightNext(); }, 50);
            }
        });

        //Almost useless for IME keyboards
        $(element).find("." + digitClassName).on("keyup", function (e) {

            //backspace 
            if (e.which === 8) {
                _deleteDigit(true);
            }
            //delete
            else if (e.which === 46) {
                _deleteDigit(false);
            }

            _updateInput();
        });

        var _onFocus = function () {
            _highlightNext();
        }

        var _highlightNext = function () {
            var $emptyDigits = $(element).find("." + digitClassName).not("." + populatedClassName);

            $allDigits.removeClass(highlightedClassName);

            //all populated
            if ($emptyDigits.length < 1) {
                $allDigits.last().focus();
                $allDigits.last().addClass(highlightedClassName);
            }
            else {
                $emptyDigits.first().focus();
                $emptyDigits.first().addClass(highlightedClassName);
            }
        }

        var _highlightPrev = function () {
            var $populatedDigits = $(element).find("." + digitClassName + "." + populatedClassName);

            if ($populatedDigits.length > 0) {
                $allDigits.removeClass(highlightedClassName);

                $populatedDigits.last().focus();
                $populatedDigits.last().addClass(highlightedClassName);
            }
        }

        var _populateDigit = function ($digit) {
            if ($digit.val().toString().trim()) {
                $digit.addClass(populatedClassName);
            }
            else {
                $digit.removeClass(populatedClassName);
            }
        }

        var _getHighlighted = function () {
            return $allDigits.filter("." + highlightedClassName).first();
        }

        var _deleteDigit = function (moveBack) {
            var $h = _getHighlighted();
            _populateDigit($h);

            if (moveBack) {
                _highlightPrev();
            }
        }

        var _getCode = function () {
            var code = "";
            $allDigits.each(function (i, d) {
                code += $(d).val().toString().trim();
            });

            return code;
        }

        var _updateInput = function () {
            var code = _getCode();
            $input.val(code);

            $(element).trigger(WidgetEvents.STEMS_ON_CHANGE, {
                code: code,
                valid: code.length == maxDigits
            });
        }

        if (focusOnLoad) {
            $(element).focus();
        }
    })
})